// src/json-src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import Firebase Auth
import { getFirestore } from "firebase/firestore";  // Import Firestore
import { getStorage } from "firebase/storage";  // Import Storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCqdEcfLZdWF5DEWPDA7V4nQV9fbQgQCxg",
  authDomain: "nashabandimandalmaharashtraraj.firebaseapp.com",
  databaseURL: "https://nashabandimandalmaharashtraraj-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "nashabandimandalmaharashtraraj",
  storageBucket: "nashabandimandalmaharashtraraj.appspot.com",
  messagingSenderId: "847324086475",
  appId: "1:847324086475:web:46c1625fdb4f460dca5b4e",
  measurementId: "G-00KYZH4BS6"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);  // Initialize Firebase Auth
const firestore = getFirestore(app);  // Initialize Firestore
const storage = getStorage(app);  // Initialize Storage

// Exporting the initialized services
export { auth, firestore, storage };
